import React from 'react';
import { observable, action, runInAction, toJS } from 'mobx';
import { observer } from 'mobx-react';
import {
  Row,
  Col,
  Switch,
  Modal,
  Button,
  Form,
  Upload,
  Avatar,
  Card,
  message,
  Divider,
  Input,
  InputNumber,
  Icon,
  Checkbox
} from 'antd';

import user_store from '@store/User/UserList/UserStore';
import update_agent_store from '@store/User/UserList/UpdateAgentStore';

import {form_item_size} from '@common/theme';

const FormItem = Form.Item;

@Form.create()
@observer
class UpdateAgentModal extends React.Component {

  formItemLayout = {
    labelCol: {
      xs: { span: 12},
      sm: { span: 9},
    },
    wrapperCol: {
      xs: { span: 12 ,offset:0},
      sm: { span: 12 ,offset:0},
    },
    //不需要提示框
    style: {
      marginBottom:0,
      textAlign:'left'
    }
  };

  formItemFullLayout = {
    labelCol: {
      xs: { span: 0 },
      sm: { span: 0},
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };

  @observable
  submitting = false;

  @observable
  password_input_type = 'password';

  @action
  togglePasswordInputType = () => {
    this.password_input_type = this.password_input_type === 'password' ? 'text' : 'password';
  };

  constructor() {
    super();
    this.state = { someKey: 'someValue' };
  }

  @action
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields( async (error, values) => {
      if(!error) {
        let temp_value = {};
        temp_value.robot_stauts         = update_agent_store.record.robot_stauts
        temp_value.is_withdrawal        = update_agent_store.record.is_withdrawal
        temp_value.recommended_status   = update_agent_store.record.recommended_status

        temp_value.radio        = values.radio.div(100);
        temp_value.radio_dg     = values.radio_dg.div(100);
        temp_value.radio_lq     = values.radio_lq.div(100);
        temp_value.radio_dglq   = values.radio_dglq.div(100);


        temp_value.password     = values.password;
        runInAction(() => {
          this.submitting = true;
        })
        let result = await update_agent_store.updateToAgent(temp_value);
        runInAction(() => {
          this.submitting = false;
        })

        if(result.success) {
          message.success(`会员 ${ update_agent_store.record.pet_name } 成功提升为代理！`, 3);
          // 重置编辑表单
          this.props.form.resetFields();
          // 关闭编辑弹出层
          update_agent_store.closeModal();
          // 重新拉数据
          user_store.reloadDatas();
        } else {
          message.error(`会员 ${ update_agent_store.record.pet_name } 提升失败！${ result.error.error_data }`, 3);
        }

        return;
      }
    })
  }

  render() {
    let { getFieldDecorator } = this.props.form;

    let input_style = {
      width: '80px',
      textAlign: 'center'
    };

    return (
      <Modal
        width={'350px'}
        visible={ update_agent_store.is_modal_show }
        // visible={ true }
        title={(
          <div
            style={{
              textAlign:'center'
            }}>
            <span>
              提升代理
            </span>
          </div>
        )}
        onCancel={ () => {
          // 重置编辑表单
          this.props.form.resetFields();
          update_agent_store.closeModal();
        } }
        footer={null}>
        <Form
        >
          <FormItem
            {...this.formItemLayout}
            label='足球串关返点'
          >
            {
              getFieldDecorator('radio', {
                initialValue:0,
                rules: [
                ]
              })(
                <InputNumber
                  placeholder=''
                  size={form_item_size}
                  style={input_style}
                  precision={1}
                  max={100}
                  min={0}
                  formatter={value => `${value}%`}
                  parser={value => value.replace('%', '')}
                  onChange={(value) => {
                    console.log("radio",value)
                  }}
                  step={0.01}/>
              )
            }
          </FormItem>
          <FormItem
              {...this.formItemLayout}
              label='足球单关返点'
          >
            {
              getFieldDecorator('radio_dg', {
                initialValue:0,
                rules: [
                ]
              })(
                  <InputNumber
                      placeholder=''
                      size={form_item_size}
                      style={input_style}
                      precision={1}
                      max={100}
                      min={0}
                      formatter={value => `${value}%`}
                      parser={value => value.replace('%', '')}
                      onChange={(value) => {
                        console.log("radio_dg",value)
                      }}
                      step={0.01}/>
              )
            }
          </FormItem>

          <FormItem
              {...this.formItemLayout}
              label='篮球串关返点'
          >
            {
              getFieldDecorator('radio_lq', {
                initialValue:0,
                rules: [
                ]
              })(
                  <InputNumber
                      placeholder=''
                      size={form_item_size}
                      style={input_style}
                      precision={ 1 }
                      max={100}
                      min={0}
                      formatter={value => `${value}%`}
                      parser={value => value.replace('%', '')}
                      onChange={(value) => {
                        console.log("radio_lq",value)
                      }}
                      step={0.001}/>
              )
            }
          </FormItem>

          <FormItem
              {...this.formItemLayout}
              label='篮球单关返点'
          >
            {
              getFieldDecorator('radio_dglq', {
                initialValue:0,
                rules: [
                ]
              })(
                  <InputNumber
                      placeholder=''
                      size={form_item_size}
                      style={input_style}
                      precision={ 1 }
                      max={100}
                      min={0}
                      formatter={value => `${value}%`}
                      parser={value => value.replace('%', '')}
                      onChange={(value) => {
                        console.log("radio_dglq",value)
                      }}
                      step={0.001}/>
              )
            }
          </FormItem>

          {/* <FormItem
            {...this.formItemLayout}
            label=' '
            colon={ false }
          >
            {
              getFieldDecorator('robot_stauts', {
                // initialValue:true,
                initialValue: update_agent_store.record.robot_stauts === 0 ? true : false,
                valuePropName:'checked',
              })(
                <Checkbox>{'允许登录'}</Checkbox>
              )
            }
          </FormItem>
          <FormItem
            {...this.formItemLayout}
            label=' '
            colon={ false }
          >
            {
              getFieldDecorator('recommended_status', {
                // initialValue:true,
                initialValue: update_agent_store.record.recommended_status === 0 ? true : false,
                valuePropName:'checked',
              })(
                <Checkbox>{'允许发展下级'}</Checkbox>
              )
            }
          </FormItem>
          <FormItem
            {...this.formItemLayout}
            label=' '
            colon={ false }>
            {
              getFieldDecorator('is_withdrawal', {
                // initialValue:true,
                initialValue: update_agent_store.record.is_withdrawal === 0 ? true : false,
                valuePropName:'checked',
                rules: [
                ]
              })(
                <Checkbox>{'允许提现'}</Checkbox>
              )
            }
          </FormItem> */}

          <FormItem
            {...this.formItemFullLayout}
          >
            {
              getFieldDecorator('password', {
                rules: [
                  {
                    required: true,
                    message: '请输入密码'
                  }
                ]
              })(
                <Input
                  placeholder='请输入密码'
                  size={form_item_size}
                  type={this.password_input_type}
                  addonAfter={
                    <Icon size={form_item_size} type="eye" onClick={this.togglePasswordInputType}/>
                  }
                />
              )
            }
          </FormItem>
          <FormItem
            {...this.formItemFullLayout}
          >
            <Button
              block
              type="primary"
              onClick={ this.handleSubmit }
              loading={ this.submitting }>
              提升为代理
            </Button>
          </FormItem>
        </Form>
      </Modal>
    );
  }

  componentDidMount() {
    this.setState({ someKey: 'otherValue' });
  }
}

export default UpdateAgentModal;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/User/UserList/UpdateAgent/UpdateAgentModal.jsx